import { render, staticRenderFns } from "./CartInfo.vue?vue&type=template&id=c0c53b74&scoped=true"
import script from "./CartInfo.vue?vue&type=script&lang=js"
export * from "./CartInfo.vue?vue&type=script&lang=js"
import style0 from "./CartInfo.vue?vue&type=style&index=0&id=c0c53b74&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0c53b74",
  null
  
)

export default component.exports